import type { ElasticQueryParams } from '@src/models/interfaces/general/ElasticQueryParams.interface';
import type { ElasticSearchResponse } from '@src/models/interfaces/general/ElasticSearchResponseInterface';
import { apiCallable } from '@src/util/cloud-functions/apiClient';
import { API_OPERATIONS } from '@src/util/cloud-functions/operations';
import safeExecute from '@src/util/safeExecute';

class ElasticQueryClient {
  async query<TSource = Record<string, unknown>>(
    params: ElasticQueryParams,
  ): Promise<ElasticSearchResponse<TSource> | null> {
    return safeExecute(
      async () => {
        const queryFn = apiCallable<ElasticQueryParams, ElasticSearchResponse<TSource>>(
          API_OPERATIONS.QUERY,
        );
        const response = await queryFn(params);
        const responseData = response.data;

        if (!responseData?.hits) {
          return null;
        }

        return responseData;
      },
      'ElasticQueryClient.query',
      {
        entity: params.entity,
        organizationId: params.organizationId,
      },
    );
  }
}

const elasticQueryClient = new ElasticQueryClient();

export default elasticQueryClient;
